import React from 'react';
import { FiPlay } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-slate-950 pb-16 pt-10 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
            <SafeIcon icon={FiPlay} className="text-white text-sm fill-current" />
          </div>
          <span className="text-white font-black text-xl tracking-tighter italic">VIDEONATION</span>
        </div>
        
        <p className="text-slate-500 text-sm font-bold tracking-widest">
          &copy; {new Date().getFullYear()} VIDEONATION INC • ALL VERTICALS SECURED
        </p>

        <div className="flex gap-6 text-slate-400 font-bold text-xs uppercase tracking-widest">
          <a href="#" className="hover:text-white transition-colors">Privacy</a>
          <a href="#" className="hover:text-white transition-colors">Terms</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;